import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    component: resolve => require(['./components/page/Login.vue'], resolve),
    meta: {
      title: '登录'
    },
  },

  {
    path: '/',
    component: resolve => require(['./components/common/Home.vue'], resolve),
    meta: {
      title: '自述文件'
    },
    children: [{
      path: '/home',
      component: resolve => require(['./components/page/index.vue'], resolve),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/photo_album',
      component: resolve => require(['./components/page/photo_album.vue'], resolve),
      meta: {
        title: '相册列表'
      }
    },
    {
      path: '/innovation_academic',
      component: resolve => require(['./components/page/innovation_academic.vue'], resolve),
      meta: {
        title: '教育教学创新'
      }
    },
    {
      path: '/photo_info',
      component: resolve => require(['./components/page/photo_info.vue'], resolve),
      meta: {
        title: '相册详情'
      }
    },

    {
      path: '/new_education',
      component: resolve => require(['./components/page/New_education.vue'], resolve),
      meta: {
        title: '新教育'
      }
    },

    {
      path: '/group',
      component: resolve => require(['./components/page/Group.vue'], resolve),
      meta: {
        title: '专题工作'
      }
    },

    {
      path: '/collective_preparation',
      component: resolve => require(['./components/page/CollectivePreparation.vue'], resolve),
      meta: {
        title: '集体备课'
      }
    },

    {
      path: '/my_class',
      component: resolve => require(['./components/page/MyClass.vue'], resolve),
      meta: {
        title: '我的班级'
      }
    },

    {
      path: '/teaching_acticle',
      component: resolve => require(['./components/page/TeachingActicle.vue'], resolve),
      meta: {
        title: '教学资源'
      }
    },
    {
      path: '/theory',
      component: resolve => require(['./components/page/Theory.vue'], resolve),
      meta: {
        title: '理论研究'
      }
    },
    {
      path: '/seminar',
      component: resolve => require(['./components/page/Seminar.vue'], resolve),
      meta: {
        title: '专题讨论'
      }
    },
    {
      path: '/weike',
      component: resolve => require(['./components/page/Weike.vue'], resolve),
      meta: {
        title: '我的微课'
      }
    },
    {
      path: '/memoir',
      component: resolve => require(['./components/page/Memoir.vue'], resolve),
      meta: {
        title: '课堂实录'
      }
    },
    {
      path: '/match',
      component: resolve => require(['./components/page/Match.vue'], resolve),
      meta: {
        title: '参赛视频'
      }
    },
    {
      path: '/live',
      component: resolve => require(['./components/page/Live.vue'], resolve),
      meta: {
        title: '直播视频'
      }
    },

    {
      path: '/statistics',
      component: resolve => require(['./components/page/Statistics.vue'], resolve),
      meta: {
        title: '资源统计'
      }
    },
    {
      path: '/visitor',
      component: resolve => require(['./components/page/visitor.vue'], resolve),
      meta: {
        title: '访客'
      }
    },

    {
      path: '/error',
      component: resolve => require(['./components/page/404.vue'], resolve),
      meta: {
        title: '404'
      }
    },
    ],
  },
  {
        path: '*',
        component: () => import('@/common/404.vue'),
    },
  ]
})